import React from 'react';
import AtlasV2RatingsProductGrid from 'src/components/AtlasV2Components/AtlasV2RatingPageCOmponents/AtlasV2RatingsProductGrid';
import { AtlasV2RatingsTopSection } from 'src/components/AtlasV2Components/AtlasV2RatingPageCOmponents/AtlasV2RatingsTopSection';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2  Ratings Page layout - Tab name: rating subtab name: rating
 */
export const AtlasV2RatingsPageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <AtlasV2RatingsTopSection />
      <AtlasV2RatingsProductGrid />
    </BasePageContainer>
  );
};
